module.exports = __webpack_public_path__ + "media/sound_lose.7acddbd5.wav";